import { Component, Inject, inject, output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { toSignal } from '@angular/core/rxjs-interop';

export interface IConfirmationDialogOptions {
  title: string;
  message: string;
  messageParams?: any;
  confirmButtonText: string;
  cancelButtonText: string;
  closable?: boolean;
  centerButtons?: boolean;
  dialogWidth?: number;
  dialogHeight?: number;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false,
})
export class ConfirmationDialogComponent {
  private readonly themeService = inject(ThemeService);
  private readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

  public readonly options = inject<IConfirmationDialogOptions>(MAT_DIALOG_DATA);
  public readonly confirmed = output<boolean>();
  public readonly theme = toSignal(this.themeService.getTheme());

  public cancel(): void {
    this.confirmed.emit(false);
    this.dialogRef.close();
  }

  public confirm(): void {
    this.confirmed.emit(true);
    this.dialogRef.close();
  }
}
